import { enUS } from './en-US';

export const translations = {
  'en-US': enUS,
};
